module.exports = "https://cdn.thelire.com/ins/resource/become_vip.21f8df43656da79a5eb237598cab2e4a.jpg";